import { PluxeeLogoLink, SwLink } from '@kaa/ui-flanders/components';
import forremLogo from '@kaa/ui-flanders/themes/wl/images/logo.svg';
import React from 'react';

type HeaderLogoProps = {
  publicUrl: string;
  homeUrl: string;
  title: string;
  mainLogoAlt: string;
};

export const HeaderLogo = ({
  publicUrl,
  homeUrl,
  title,
  mainLogoAlt,
}: HeaderLogoProps) => {
  return (
    <>
      <SwLink to={homeUrl} className="site-bar__link">
        <div className="site-bar__separator">
          <span className="site-bar__title hideMobile">{title}</span>
          <span className="site-bar__title site-bar__mobileTitle showMobile">
            <PluxeeLogoLink imageClassName="logo_pluxee" />
            {title}
          </span>
        </div>
      </SwLink>
      <SwLink to={publicUrl} className="site-bar__logo" target="_blank">
        <img
          src={forremLogo}
          alt={mainLogoAlt}
          className="site-bar__logo--image"
        />
      </SwLink>
    </>
  );
};
